var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2935_386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 61C47.3447 61 61 47.3447 61 30.5C61 13.6553 47.3447 0 30.5 0C13.6553 0 0 13.6553 0 30.5C0 47.3447 13.6553 61 30.5 61Z",
    fill: "#BBEC6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5001 0C29.8815 0 29.2678 0.0206197 28.6583 0.0569497C44.6451 1.00951 56.5336 14.2739 56.5336 30.5C56.5336 46.7261 44.6451 59.9905 28.6582 60.943C29.2678 60.9794 29.8815 61 30.5001 61C47.3448 61 61.0001 47.3447 61.0001 30.5C61.0001 13.6553 47.3448 0 30.5001 0Z",
    fill: "#A2E62E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5003 56.5335C44.8782 56.5335 56.5338 44.8779 56.5338 30.5C56.5338 16.1221 44.8782 4.46649 30.5003 4.46649C16.1224 4.46649 4.4668 16.1221 4.4668 30.5C4.4668 44.8779 16.1224 56.5335 30.5003 56.5335Z",
    fill: "#4FC123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 4.46649C29.8807 4.46649 29.2667 4.48969 28.6582 4.53216C42.1765 5.47723 52.8499 16.7415 52.8499 30.5C52.8499 44.2586 42.1765 55.5228 28.6582 56.4678C29.2667 56.5104 29.8807 56.5335 30.5 56.5335C44.8779 56.5335 56.5335 44.8778 56.5335 30.5C56.5335 16.1222 44.8779 4.46649 30.5 4.46649Z",
    fill: "#47A920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2474 25.2653L29.6301 41.8838C27.8676 43.6451 25.0128 43.6451 23.2515 41.8838L14.7532 33.3855C13.7763 32.4098 13.7763 30.8265 14.7532 29.8507L17.2301 27.3739V27.3727L18.0696 26.5332C19.0453 25.5574 20.6286 25.5574 21.6044 26.5332L25.8572 30.786C26.3138 31.2438 27.0563 31.2438 27.5129 30.786L39.6405 18.6584C40.6163 17.6826 42.1996 17.6826 43.1753 18.6584L46.2474 21.7305C47.2244 22.7075 47.2244 24.2895 46.2474 25.2653Z",
    fill: "#D1F19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5123 30.786L26.1046 32.1937C25.5498 32.7497 24.6501 32.7534 24.0892 32.2023L19.7849 27.9765C19.0939 27.2843 18.0985 27.0855 17.2295 27.3739V27.3727L18.069 26.5331C19.0448 25.5574 20.6281 25.5574 21.6038 26.5331L25.8566 30.786C26.3132 31.2438 27.0558 31.2438 27.5123 30.786Z",
    fill: "#BBEC6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.247 21.7309L43.1746 18.6585C42.1985 17.6824 40.6159 17.6824 39.6398 18.6585L38.8455 19.4529C39.5605 19.3862 40.2988 19.6263 40.8462 20.1738L42.5633 21.731C43.5394 22.7071 43.5394 24.2897 42.5633 25.2658L27.3233 40.7058C26.2353 41.7938 24.7296 42.2088 23.3223 41.9525C25.0886 43.644 27.8909 43.622 29.6287 41.8842L46.2471 25.2658C47.2231 24.2897 47.2231 22.707 46.247 21.7309Z",
    fill: "#BBEC6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2935_386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b1c6a4a6a161bc2f58f9f1c4644c1a38.svg";
export { ForwardRef as ReactComponent };